document.addEventListener('DOMContentLoaded', function() {
    // Check if the body has the specific ID 'delivery-page'
    if (document.body.id !== 'delivery-page') {
        return; // Exit if not the 'delivery-page'
    }

    // Placeholder values for client_country and client_continent
    let client_country = undefined;
    let client_continent = undefined;

    // Fetch the client's country and continent using ipgeolocation.io
    fetch("https://api.ipgeolocation.io/ipgeo?apiKey=4c105c5b2432429894c5cbebca414688&fields=country_code2,continent_code")
    .then(response => response.json())
    .then(data => {
        client_country = data.country_code2;
        client_continent = data.continent_code;

        // Ensure geolocation lookup was successful
        if (client_country === undefined && client_continent === undefined) {
            console.log("Geolocation lookup failed.");
        } else {
            // After successful lookup, display the relevant tab
            displayRelevantTab(client_country, client_continent);
        }
    })
    .catch(error => {
        console.log(error);
    });

    function displayRelevantTab(client_country, client_continent) {
        let targetTabRegion;

        // Logic to determine which tab should be active based on client_country or client_continent
        if (client_country === 'GB') {
            targetTabRegion = 'united-kingdom';
        } else if (client_country === 'US') {
            targetTabRegion = 'united-states';
        } else if (client_continent === 'EU') {
            targetTabRegion = 'europe';
        } else {
            targetTabRegion = 'worldwide';
        }

        // Activate the relevant tab and content
        if (targetTabRegion) {
            document.querySelectorAll('.section-content-tabs__page').forEach((page) => {
                page.classList.remove('active');
            });

            document.querySelectorAll('.button--toggle').forEach((button) => {
                button.classList.add('button--secondary');
            });

            const activeTabContent = document.querySelector(`[data-tab-region="${targetTabRegion}"]`);
            const targetTabId = activeTabContent.id;
            const activeTabButton = document.querySelector(`.button--toggle[data-target="${targetTabId}"]`);

            if (activeTabContent && activeTabButton) {
                activeTabContent.classList.add('active');
                activeTabButton.classList.remove('button--secondary');
            }
        }
    }
});
